import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import ListingBadge, { BADGE_MODE, BADGE_ORDER_PRIORITY } from './base';
import { isForeclosure } from './utils';
export default class FirstLookBadge extends ListingBadge {
    static title = 'First Look Program';
    static titleIcon = 'door-open';
    static textIcon = 'check';
    static titleV2 = 'First Look';
    static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.FOURTH;
    static shouldBeIncluded(listing, badgeMode) {
        if (badgeMode === BADGE_MODE.CONDENSED)
            return false;
        const isFirstLookEnabled = _.get(listing, 'listing_configuration.is_first_look_enabled', '');
        return isFirstLookEnabled;
    }
    static shouldBeIncludedV2(listing, badgeMode) {
        return this.shouldBeIncluded(listing, badgeMode) && !isForeclosure(listing);
    }
    get content() {
        const formattedFirstLookDate = moment(this.props.listing.listing_configuration.first_look_end_date).format('MM/DD/YYYY');
        return (_jsxs("span", { children: ["Sold only to buyers who intend to live in the property or Approved Entities, until ", formattedFirstLookDate, "."] }));
    }
}
//# sourceMappingURL=firstLook.js.map